module.exports = __webpack_public_path__ + "static/media/f_3.5b9e9b6c.jpg";